import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Timetable } from '../../models/timetable.model';
import { Amenity } from '../../models/amenity.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { TimetableService } from '../../services/timetable.service';

@Component({
  selector: 'app-timetable-item',
  templateUrl: './timetable-item.component.html',
  styleUrl: './timetable-item.component.scss'
})
export class TimetableItemComponent {

  @Input() timetable?: Timetable;
  @Input() amenity?: Amenity;
  // @Input() getData?: () => void;
  @Output() getData:EventEmitter<any> = new EventEmitter<any>();
  @Output() closeModal:EventEmitter<any> = new EventEmitter<any>();

  public time: any;

  public formTimetable: FormGroup;
  public submitted: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private timetableService: TimetableService,
  ) {

    this.formTimetable = this.formBuilder.group({
      startHour: ['', Validators.required],
      endHour: ['', Validators.required],
      monday: [false],
      tuesday: [false],
      wednesday: [false],
      thursday: [false],
      friday: [false],
      saturday: [false],
      sunday: [false],
    });

  }

  ngOnInit(): void {
    if(this.timetable) {   
      
      const startHour = moment(
        moment().format('YYYY-MM-DD') + ' ' + this.timetable.startHour,
      ).toDate();

      const endHour = moment(
        moment().format('YYYY-MM-DD') + ' ' + this.timetable.endHour,
      ).toDate();

      this.formTimetable.patchValue({
        startHour: startHour,
        endHour: endHour,
        monday: this.timetable.monday,
        tuesday: this.timetable.tuesday,
        wednesday: this.timetable.wednesday,
        thursday: this.timetable.thursday,
        friday: this.timetable.friday,
        saturday: this.timetable.saturday,
        sunday: this.timetable.sunday,
      });

      // this.formTimetable.controls['startHour'].setValue(this.timetable.startHour);
      // this.formTimetable.controls['endHour'].setValue(this.timetable.endHour);
      // this.formTimetable.controls['monday'].setValue(this.timetable.monday);
      // this.formTimetable.controls['tuesday'].setValue(this.timetable.tuesday);
      // this.formTimetable.controls['wednesday'].setValue(this.timetable.wednesday);
      // this.formTimetable.controls['thursday'].setValue(this.timetable.thursday);
      // this.formTimetable.controls['friday'].setValue(this.timetable.friday);
      // this.formTimetable.controls['saturday'].setValue(this.timetable.saturday);
      // this.formTimetable.controls['sunday'].setValue(this.timetable.sunday);

    }
  }

  onSubmit() {
    
    this.submitted = true;
    
    console.log(this.formTimetable.value);

    if(this.formTimetable.invalid) {
      return;
    }

    this.formTimetable.value.startHour = moment(this.formTimetable.value.startHour).format('HH:mm');
    this.formTimetable.value.endHour = moment(this.formTimetable.value.endHour).format('HH:mm');

    console.log(this.formTimetable.value);

    if(this.timetable) {
      this.update();
    } else {
      this.create();
    }
    
  }

  /*
   ██████╗██████╗ ███████╗ █████╗ ████████╗███████╗
  ██╔════╝██╔══██╗██╔════╝██╔══██╗╚══██╔══╝██╔════╝
  ██║     ██████╔╝█████╗  ███████║   ██║   █████╗
  ██║     ██╔══██╗██╔══╝  ██╔══██║   ██║   ██╔══╝
  ╚██████╗██║  ██║███████╗██║  ██║   ██║   ███████╗
   ╚═════╝╚═╝  ╚═╝╚══════╝╚═╝  ╚═╝   ╚═╝   ╚══════╝

  */
  async create() {

    await this.timetableService.create(
      this.amenity!,
      this.formTimetable.value
    );

    await this.getData.emit();
    this.formTimetable.reset();
    this.formTimetable.patchValue({
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      sunday: false,
    });

    this.closeModal.emit();

  }

  async delete() {

    const flag = confirm('¿Está seguro de eliminar el horario?');
    if(flag) {
      await this.timetableService.delete(
        this.amenity!,
        this.timetable!
      );

      await this.getData.emit();
    }

    this.closeModal.emit();

  }

  /*
  ██╗   ██╗██████╗ ██████╗  █████╗ ████████╗███████╗
  ██║   ██║██╔══██╗██╔══██╗██╔══██╗╚══██╔══╝██╔════╝
  ██║   ██║██████╔╝██║  ██║███████║   ██║   █████╗
  ██║   ██║██╔═══╝ ██║  ██║██╔══██║   ██║   ██╔══╝
  ╚██████╔╝██║     ██████╔╝██║  ██║   ██║   ███████╗
   ╚═════╝ ╚═╝     ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚══════╝

  */
  async update() {

    this.formTimetable.value.timetableId = this.timetable!.timetableId;

    await this.timetableService.update(
      this.amenity!,
      this.formTimetable.value
    );

    this.getData.emit();

    this.closeModal.emit();

  }

}
